import {useState} from "react";

function useHttp(requestConfig, applyData) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null)

    async function sendRequest() {
        setIsLoading(true);
        setError(null);

        // Check required for authentication requests
        let requestBody;
        if (requestConfig.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
            requestBody = requestConfig.body
        } else {
            requestBody = JSON.stringify(requestConfig.body)
        }

        try {
            const response = await fetch(
                requestConfig.url,
                {
                    method: requestConfig.method ? requestConfig.method : 'GET',
                    headers: requestConfig.headers ? requestConfig.headers : {},
                    handleAs: 'json',
                    body: requestConfig.body ? requestBody : null
                }
            );
            if (!response.ok) {
                throw new Error('Request failed')
            }
            const data = await response.json()
            applyData(data);
        } catch (err) {
            setError(err.message || 'Something went wrong')
        }
        setIsLoading(false)
    }

    return {
        isLoading: isLoading,
        error: error,
        sendRequest: sendRequest
    }
}

export default useHttp;